import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import HomeIndex from '../views/HomeIndex.vue'
import Usercenter from '../views/Usercenter.vue'
import Login from '../views/Login.vue'
import Reguser from '../views/Reguser.vue'
import ForgetPwd from '../views/ForgetPwd.vue'

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/reguser',
    name: 'Reguser',
    component: Reguser
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    // 忘记密码：独立页面（由登录页「忘记密码？」跳入）
    path: '/forget',
    name: 'ForgetPwd',
    component: ForgetPwd
  },

  {
    // Home 现在只承担"侧边栏 + 主内容区"的布局壳，具体页面由子路由决定
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: false }, // bu需要身份验证的路由
    redirect: '/home/index',
    children: [
      {
        // 首页：banner + 最近去过的村子 + 各分类卡片
        path: 'index',
        name: 'HomeIndex',
        component: HomeIndex
      },
      {
        // 用户中心：由原弹窗改造为独立路由页面
        path: 'usercenter',
        name: 'Usercenter',
        component: Usercenter
      }
    ]
  },

  {
    path: '/',
    redirect: '/home'
  }

]

const router = new VueRouter({
  routes

})


// 无需验证token的页面
const whiteList = ['/login', '/reguser', '/forget', '/home'] // 将 home 加入白名单

// 白名单放行判断：/home 及其子路由（/home/index、/home/usercenter）都算白名单内，
// 避免根路径重定向到子路由后被守卫拦到登录页
const isWhiteListed = (path) =>
  whiteList.some((white) => path === white || path.startsWith(white + '/'))

router.beforeEach(async (to, from, next) => {
  const token = store.state.token

  // 如果有 token
  if (token) {
    if (!store.state.userInfo.email) {
      // 有token但是没有用户信息, 才去请求用户信息保存到vuex里
      try {
        await store.dispatch('getUserInfoActions')
      } catch (e) {
        // 拉取用户信息失败（断网/超时/token 失效）：
        // 清除登录态并引导到登录页，避免导航被拒绝导致页面卡死
        store.commit('clearUser')
        return next('/login')
      }
    }
    next() // 路由放行
  } else {
    // 如果无 token
    if (isWhiteListed(to.path)) {
      next() // 如果去的是白名单页面, 则放行
    } else {
      // 如果访问需要身份验证的页面则跳转到登录页面
      next('/login')
    }
  }
})

export default router
